const INVENTORY_LOAD = 'INVENTORY_LOAD';
const INVENTORY_LOAD_SUCCESS = 'INVENTORY_LOAD_SUCCESS';
const INVENTORY_LOAD_FAIL = 'INVENTORY_LOAD_FAIL';

const INVENTORY_CHANGE_STOCK_STATUS = 'INVENTORY_CHANGE_STOCK_STATUS';
const INVENTORY_CHANGE_STOCK_STATUS_SUCCESS = 'INVENTORY_CHANGE_STOCK_STATUS_SUCCESS';
const INVENTORY_CHANGE_STOCK_STATUS_FAIL = 'INVENTORY_CHANGE_STOCK_STATUS_FAIL';

const INVENTORY_UPDATE_TYPE = 'INVENTORY_UPDATE_TYPE';
const INVENTORY_UPDATE_TYPE_SUCCESS = 'INVENTORY_UPDATE_TYPE_SUCCESS';
const INVENTORY_UPDATE_TYPE_FAIL = 'INVENTORY_UPDATE_TYPE_FAIL';

export const onInventoryLoad = (restId) => ({type: INVENTORY_LOAD, restId })
export const onInventoryLoadSuccess = (data) => ({type: INVENTORY_LOAD_SUCCESS, data })
export const onInventoryLoadFail = (e) => ({type: INVENTORY_LOAD_FAIL, e })

export const onInventoryChangeStockStatus = (restId, item, status) => ({
    type: INVENTORY_CHANGE_STOCK_STATUS,
    restId,
    item,
    status
})
export const onInventoryChangeStockStatusSuccess = () => ({type: INVENTORY_CHANGE_STOCK_STATUS_SUCCESS })
export const onInventoryChangeStockStatusFail = (e) => ({type: INVENTORY_CHANGE_STOCK_STATUS_FAIL, e })

export const onInventoryUpdateType = (restId, item, orderType) => ({
    type: INVENTORY_UPDATE_TYPE,
    restId,
    item,
    orderType
})
export const onInventoryUpdateTypeSuccess = () => ({type: INVENTORY_UPDATE_TYPE_SUCCESS })
export const onInventoryUpdateTypeFail = (e) => ({type: INVENTORY_UPDATE_TYPE_FAIL, e })

export const onInventoryUpdateStockLimit = (restId, item, limit) => ({type:'inventory/stock_limit/update', restId, item, limit})
export const onInventoryUpdateStockLimitSuccess = () => ({type:'inventory/stock_limit/update/success' })
export const onInventoryUpdateStockLimitFail = (e) => ({type:'inventory/stock_limit/update/fail', e })


